/**
 * Tree helper functions for cascade collection - OPTIMIZED
 */
import { ILvl1Item, ILvl2Item, ILvl3Item, ILvl4Item } from '../types'
import { calculateRelevanceOptimized } from './searchMatcher'

export interface FilteredLv4 {
  item: ILvl4Item
  relevance: number
}

/** Enrich LV4 item with parent metadata */
export const enrichLv4 = (
  lv4: ILvl4Item,
  lv1: ILvl1Item,
  lv2: ILvl2Item,
  type: 'skill' | 'content'
): ILvl4Item => ({
  ...lv4,
  type,
  lv1ID: lv1.id,
  lv1Name: lv1.name,
  lv2ID: lv2.id,
  lv2Name: lv2.name,
  color: lv4.color || lv1.color || '#6c757d'
})

/** Collect all LV4 from LV3 (cascade from LV3 match) - uses normalized term */
export const collectLv4FromLv3 = (
  lv3: ILvl3Item,
  lv1: ILvl1Item,
  lv2: ILvl2Item,
  normalizedTerm: string,
  type: 'skill' | 'content'
): FilteredLv4[] => {
  if (!lv3.children?.length) return []

  return lv3.children.map(lv4 => ({
    item: enrichLv4(lv4, lv1, lv2, type),
    relevance: calculateRelevanceOptimized(
      lv4.name, lv4.originalCodes, normalizedTerm, false, true
    )
  }))
}

/** Collect all LV4 from LV2 (cascade from LV2 match) - uses normalized term */
export const collectLv4FromLv2 = (
  lv2: ILvl2Item,
  lv1: ILvl1Item,
  normalizedTerm: string,
  type: 'skill' | 'content'
): FilteredLv4[] => {
  if (!lv2.children?.length) return []

  const results: FilteredLv4[] = []
  for (const lv3 of lv2.children) {
    if (!lv3.children?.length) continue
    for (const lv4 of lv3.children) {
      results.push({
        item: enrichLv4(lv4, lv1, lv2, type),
        relevance: calculateRelevanceOptimized(
          lv4.name, lv4.originalCodes, normalizedTerm, true, false
        )
      })
    }
  }
  return results
}
